module.exports = __webpack_public_path__ + "img/20210703_161603.fc887bee.jpg";